import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ds-card-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="ds-card-footer"><ng-content /></div>`,
  styles: [`
    .ds-card-footer {
      margin-top: auto;
      padding-top: 16px;
      border-top: 1px dashed rgba(0, 0, 0, 0.12);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }
  `],
})
export class DsCardFooterComponent {}
